"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.motIDs = void 0;
const ruleID_model_1 = require("./ruleID.model");
exports.motIDs = [
    ruleID_model_1.RuleID.MoT04_EV01_CRD_Other,
    ruleID_model_1.RuleID.MoT04_EV02_CRD_Major,
    ruleID_model_1.RuleID.MoT04_EV03_CRD_LastMinute,
    ruleID_model_1.RuleID.MoT04_EV04_CRD_NotInTime,
    ruleID_model_1.RuleID.MoT02_EV02_RolledCargo,
    ruleID_model_1.RuleID.MoT01_EV01_MainCarriagePOL,
    ruleID_model_1.RuleID.MoT01_EV02_MainCarriagePOD,
    ruleID_model_1.RuleID.MoT01_EV03_MissedVesselTS,
    ruleID_model_1.RuleID.MoT01_EV04_MainCarriagePOLTS,
    ruleID_model_1.RuleID.MoT01_EV05_MainCarriagePODTS,
    ruleID_model_1.RuleID.MoT02_EV01_Customs_ClearedNoInspection,
    ruleID_model_1.RuleID.MoT02_EV02_Customs_DocumentInspection,
    ruleID_model_1.RuleID.MoT02_EV03_Customs_PhysicalInspection,
    ruleID_model_1.RuleID.MoT02_EV04_Customs_ClearedAfterInspection,
    ruleID_model_1.RuleID.MoT02_EV05_Customs_CustomsException,
    ruleID_model_1.RuleID.MoT02_DEM01_DemFreeDaysUpdated,
    ruleID_model_1.RuleID.MoT02_DEM02_DemFreeDaysExceededInPort,
    ruleID_model_1.RuleID.MoT02_DEM03_DemFreeDaysExceededLeftPort,
    ruleID_model_1.RuleID.MoT02_DEM04_DemPlannedTransport,
    ruleID_model_1.RuleID.MoT02_DEM05_DemPreFreeDaysExceededLeftPort,
    ruleID_model_1.RuleID.MoT02_DEM05_DemFreeDaysExceededLeftPort,
    ruleID_model_1.RuleID.MoT02_DET03_DetFreeDaysExceededContainerReturned,
    ruleID_model_1.RuleID.MoT02_DET04_DetPlannedTransport,
    ruleID_model_1.RuleID.MoT02_DET05_DetPreFreeDaysExceededContainerReturned,
    ruleID_model_1.RuleID.MoT02_DET05_DetFreeDaysExceededContainerReturned,
    ruleID_model_1.RuleID.MoT02_DEMDET01_DemDetFreeDaysBeforeVesselArrived,
    ruleID_model_1.RuleID.MoT02_DEMDET02_DemDetFreeDaysVesselArrived,
    ruleID_model_1.RuleID.MoT02_DEMDET03_DemDetFreeDaysExceededContainerReturned,
    ruleID_model_1.RuleID.MoT02_DEMDET04_DemDetPlannedTransport,
    ruleID_model_1.RuleID.MoT02_DEMDET05_DemDetPreFreeDaysExceededContainerReturned,
    ruleID_model_1.RuleID.MoT02_DEMDET05_DemDetFreeDaysExceededContainerReturned,
    ruleID_model_1.RuleID.MoT02_EV01_BookingCreated,
    ruleID_model_1.RuleID.MoT02_EV02_BookingConfirmedByCarrier,
    ruleID_model_1.RuleID.MoT02_EV03_BookingCancelled,
];
//# sourceMappingURL=motIDs.model.js.map